import React from 'react';
import { useDispatch } from 'react-redux';

import Header from '../../../../Components/Header';
import { IN_PROGRESS, SUCCESS_MESSAGE, ERROR, LOGOUT } from '../../../../Constants';
import * as UserAction from '../../../../Store/Actions/User';
import { clearAccessToken } from '../../../../Utils';
import { CreditDeposit } from '../../../../Components/Admin/Users/CreditDeposit';
import { FooterMenu } from '../../../../Components/FooterMenu';
import { UserActions } from '../../../../Store/Actions';

export const ManagerDepositCredit = () => {
  const dispatch = useDispatch();

  const submit = (payload, callback) => {
    dispatch({ type: IN_PROGRESS });
    UserAction.creditTransfers(payload)
      .then((response) => {
        if (response.data.success) {
          UserActions.getUserBalanceAndMessages();
          UserActions.getUsers();
          callback();
          dispatch({
            type: SUCCESS_MESSAGE,
            data: {
              message: `Amount ${payload.amount} transferred successfully`,
            },
          });
        } else {
          dispatch({
            type: ERROR,
            data: { error_msg: response.data.message },
          });
        }
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 403) {
            clearAccessToken();
            dispatch({
              type: LOGOUT,
            });
          } else
            dispatch({
              type: ERROR,
              data: { error_msg: error.response.data.message },
            });
        } else {
          dispatch({
            type: ERROR,
            data: { error_msg: error.message.toString() },
          });
        }
      });
  };

  return (
    <div className='agent_layout'>
      <Header name={'Deposit Credit'} />
      <CreditDeposit submit={submit} />
      <FooterMenu isManager={true}/>
    </div>
  );
};
